package com.rylcart.cp.ui.components

import androidx.compose.runtime.Composable
import com.rylcart.cp.ui.state.LocalApp
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event

@Composable
fun PrimaryButton(label: String, disabled: Boolean = false, onClick: () -> Unit) {
    Button(attrs = {
        classes("btn", "primary")
        if (disabled) attr("disabled", "")
        onClick { onClick() }
    }) { Text(label) }
}

@Composable
fun SecondaryButton(label: String, onClick: () -> Unit) {
    Button(attrs = {
        classes("btn", "secondary")
        onClick { onClick() }
    }) { Text(label) }
}

@Composable
fun DangerButton(label: String, onClick: () -> Unit) {
    Button(attrs = {
        classes("btn", "danger")
        onClick { onClick() }
    }) { Text(label) }
}

@Composable
fun TextField(
    label: String,
    value: String,
    placeholder: String? = null,
    type: org.jetbrains.compose.web.attributes.InputType<String> = org.jetbrains.compose.web.attributes.InputType.Text,
    hint: String? = null,
    onChange: (String) -> Unit,
) {
    Div(attrs = { classes("field") }) {
        Label { Text(label) }
        Input(type = type) {
            value(value)
            placeholder?.let { placeholder(it) }
            onInput { onChange((it.target as HTMLInputElement).value) }
        }
        hint?.let { Div(attrs = { classes("hint") }) { Text(it) } }
    }
}

@Composable
fun StatusBadge(status: String) {
    val cls = when (status) {
        "active", "succeeded"                          -> "ok"
        "provisioning", "running", "destroying"        -> "info"
        "failed", "destroy_failed"                     -> "err"
        "pending"                                      -> "warn"
        else                                           -> "neutral"
    }
    Span(attrs = { classes("badge", cls) }) { Text(status) }
}

@Composable
fun Toast() {
    val app = LocalApp.current
    val t = app.toast ?: return
    Div(attrs = { classes("toast", if (t.isError) "err" else "ok"); onClick { app.toast = null } }) {
        Text(t.text)
    }
}
